import { DEFAULT_NAMESPACES } from '@/utils';
import type { SupportedLanguage } from '@/utils/globalTypes';

import { getClientNamespaceResources } from './clientResources';

import type { i18n as I18nInstance } from 'i18next';

export async function loadClientNamespaces(i18n: I18nInstance, lang: SupportedLanguage, namespaces: string[] = []) {
  const allNamespaces = Array.from(new Set([...DEFAULT_NAMESPACES, ...namespaces]));

  allNamespaces.forEach((namespace) => {
    if (i18n.hasResourceBundle(lang, namespace)) return;

    const resources = getClientNamespaceResources(lang, namespace);

    i18n.addResourceBundle(lang, namespace, resources, true, true);
  });

  if (i18n.resolvedLanguage !== lang) {
    await i18n.changeLanguage(lang);
  }
}
